// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"5f2fd60f","849":"cfcbc35c"}[chunkId] + ".chunk.css";
};